import JSZip from "jszip";
import { api } from "@/lib/api";
import { pdfBlob, xlsxBlob } from "@/lib/exporters";
import { annualSections } from "@/lib/annual";
import { buildConference, conferenceSections } from "@/lib/conference";
import { fmtDate } from "@/lib/format";

const names = (l) => l.map((o) => o.name);
const KEYS = [["tithes", "Tithes"], ["donations", "Conference Collection"], ["registrations", "Registrations"]];
const safe = (s) => s.replace(/[^\w\- ]+/g, "").trim().replace(/\s+/g, "-");

export function financialSections(rows) {
  const tot = Object.fromEntries(KEYS.map(([k]) => [k, rows.reduce((a, r) => a + r[k], 0)]));
  const grand = KEYS.reduce((a, [k]) => a + tot[k], 0);
  return [
    { title: "Totals by category", head: ["Category", "Total"], body: KEYS.map(([k, l]) => [l, tot[k]]), foot: ["GRAND TOTAL", grand], moneyCols: [1] },
    { title: "By church", head: ["Church", ...KEYS.map(([, l]) => l), "Total"], body: rows.map((r) => [r.church_name, ...KEYS.map(([k]) => r[k]), KEYS.reduce((a, [k]) => a + r[k], 0)]), foot: ["TOTAL", ...KEYS.map(([k]) => tot[k]), grand], moneyCols: [1, 2, 3, 4, 5] },
  ];
}

function add(zip, name, title, subtitle, sections, sig) {
  zip.file(`${name}.pdf`, pdfBlob(title, subtitle, sections, sig));
  zip.file(`${name}.xlsx`, xlsxBlob(sections, sig));
}

export async function buildReportsZip(ctx, year, sig) {
  const zip = new JSZip();
  const printed = `Printed ${fmtDate(new Date().toISOString())}`;
  const [t, d, f] = await Promise.all([api.get("/tithes", { params: { year } }), api.get("/donations", { params: { year } }), api.get("/financial-summary", { params: { year } }).catch(() => null)]);
  const annual = annualSections({ scope: "All churches", churches: ctx.churches, tithes: t.data, donations: d.data, destNames: names(ctx.options.destinations), categoryNames: names(ctx.options.categories), show: { tithes: true, donations: true }, toggles: ctx.settings?.annual_sections || {} });
  const h = ctx.settings?.annual || {};
  add(zip, `Annual-Summary-${year}`, `${h.title || "MWJK Annual Summary Report"} ${year}`, `${h.subtitle || ""} · ${printed}`, annual, sig);
  if (f) add(zip, `Financial-Summary-${year}`, "MWJK Financial Summary", `All churches · Year ${year} · ${printed}`, financialSections(f.data.rows), sig);
  for (const col of ctx.options.collections) {
    const r = await api.get("/conference-summary", { params: { collection: col.name } }).catch(() => null);
    if (!r || !(r.data.donations.length || r.data.registrations.length || r.data.expenses.length)) continue;
    const m = buildConference({ regions: ctx.regions, churches: ctx.churches, collection: col, data: r.data });
    add(zip, `Conference-Summary-${safe(col.name)}`, `MWJK Conference Summary - ${col.name}`, `Full Detail · ${printed}`, conferenceSections(m, true), sig);
  }
  return zip.generateAsync({ type: "blob" });
}

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
